export enum ECaseStatus {
  NEW = 'new',
  FLAGGED = 'flagged',
  SUBMITTED = 'submitted',
}
